import script from "./OrderApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderApp.vue?vue&type=script&setup=true&lang=ts"

import "./OrderApp.vue?vue&type=style&index=0&id=ed1cc294&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed1cc294"]])

export default __exports__